import { Component } from '@theme/component';
/** Preserve native fragment navigation while resolving merchant-added section identities. */
class BroxPiJump extends Component {
  /** @param {MouseEvent} event - Pointer or keyboard activation routed by Component. */
  handleJump(event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[data-pi-target]');
    if (!(link instanceof HTMLAnchorElement) || !this.contains(link)) return;
    const selector = link.dataset.piTarget === 'inputs' ? '.brox-pi-features__grid' : '.brox-pi-report';
    const target = document.querySelector(selector);
    if (target instanceof HTMLElement && target.id) link.hash = target.id;
  }
}
if (!customElements.get('brox-pi-jump-component')) customElements.define('brox-pi-jump-component', BroxPiJump);
/** Optional presentation animation; values always come from Liquid and remain visible without JS. */
class BroxPiReport extends Component {
  #observer;
  connectedCallback() { super.connectedCallback(); this.#bind(); }
  updatedCallback() { super.updatedCallback(); this.#bind(); }
  disconnectedCallback() { this.#observer?.disconnect(); super.disconnectedCallback(); }
  #bind() {
    this.#observer?.disconnect();
    if (this.dataset.animate !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    this.#observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      this.dataset.visible = 'true';
      this.#observer?.disconnect();
    }, { threshold: 0.2 });
    this.#observer.observe(this);
  }
}
if (!customElements.get('brox-pi-report-component')) customElements.define('brox-pi-report-component', BroxPiReport);
